import { Navigate, useParams, useLocation } from "react-router-dom";

/** Oude /betaal/:code-links uit eerdere mails → nieuwe route /betalen/:token. */
const LegacyBetaalRedirect = () => {
  const { code } = useParams<{ code: string }>();
  const { search } = useLocation();
  return <Navigate to={`/betalen/${code ?? ""}${search}`} replace />;
};

export default LegacyBetaalRedirect;
